/* eslint-disable */
import {
  Divider,
  createStyles,
  Theme,
  withStyles,
  AccordionActions,
} from "@material-ui/core";
import { Button as ButtonMat } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import {
  getSecLetterTemplateList,
  getSecLetterByName,
  addHTMLSecTemplates,
  addJSONSecTemplates,
} from "../../../utils/store/actions/funds.actions";
import { withTranslation } from "react-i18next";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DropzoneArea } from "material-ui-dropzone";
import React, { Component } from "react";
import { connect } from "react-redux";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });
class SecTemplateConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    await this.props.getSecLetterTemplateList();
  }

  // DOWNLOAD Sec TEMPLATE
  downloadSecTemplates = (templateName: string) => {
    let filename = templateName.includes("/")
      ? templateName.split("/")[1]
      : templateName;
    this.props.getSecLetterByName(filename).then(() => {
      var element = document.createElement("a");
      let splitFilename = filename.split(".");
      let newFilename: any = "";
      if (splitFilename[splitFilename.length - 1] === "json") {
        newFilename = JSON.stringify(this.props.Funds.sec_letter);
      } else {
        newFilename = this.props.Funds.sec_letter;
      }
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(newFilename)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  };
  // HANDLE CHANGE Sec
  handleChangeSec(secTemplates: any) {
    this.setState({
      secTemplates,
    });
    secTemplates.map((template: any) => {
      if (template.type === "text/html") {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          htmlSecTemplates: file,
        });
      } else {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          jsonSecTemplates: file,
        });
      }
    });
  }
  // UPLOAD Sec TEMPLATES
  uploadSecLetter() {
    this.state.secTemplates.map((template: any) => {
      if (template.type === "text/html") {
        this.props.addHTMLSecTemplates(this.state.htmlSecTemplates);
      } else {
        this.props.addJSONSecTemplates(this.state.jsonSecTemplates);
      }
    });
    this.props.getSecLetterTemplateList();
  }

  render() {
    const { classes, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="SecTemplatesContainer"
        >
          <Typography className={classes.heading}>
            {t("SEC_TEMPLATES")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            className={classes.heading}
            style={{ marginLeft: "20px" }}
          >
            {t("BS_TEMPLATES_TO_DOWNLOAD")}
          </Typography>
          <div style={{ margin: "20px" }}>
            {this.props.Funds?.sec_letter_list &&
              this.props.Funds.sec_letter_list.map((template: any) => {
                return (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => this.downloadSecTemplates(template)}
                  >
                    <FiberManualRecordIcon
                      style={{
                        display: "flex",
                        fontSize: "8px",
                        color: "ae0064",
                      }}
                    />
                    <li>
                      {template.includes("/")
                        ? template.split("/")[1]
                        : template}
                    </li>{" "}
                    <GetAppIcon />
                  </div>
                );
              })}
          </div>
        </AccordionDetails>
        <AccordionDetails
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DropzoneArea
            dropzoneClass={classes.dropzone}
            showFileNames
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            acceptedFiles={["text/html", "application/json"]}
            previewGridProps={{
              container: { spacing: 1, direction: "column" },
            }}
            previewChipProps={{ classes: { root: classes.previewChip } }}
            previewText="File:"
            dropzoneText={t("UPLOAD")}
            filesLimit={2}
            onChange={this.handleChangeSec.bind(this)}
          />
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <ButtonMat
            size="small"
            style={{ color: "#ae0064" }}
            onClick={() => {
              this.uploadSecLetter();
            }}
          >
            {t("SAVE")}
          </ButtonMat>
        </AccordionActions>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getSecLetterTemplateList,
  getSecLetterByName,
  addHTMLSecTemplates,
  addJSONSecTemplates,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(SecTemplateConfiguration)));
